import { Stars } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

const ShowFavoritesButton = ({ onClick }) => {
  return (
    <Tooltip title="لیست علاقمندی ها">
      <button
        onClick={onClick}
        className={"btn btn-blue"}
        style={{ width: "fit-content" }}
      >
        <Stars sx={{ width: "24px" }} />
      </button>
    </Tooltip>
  );
};

export default ShowFavoritesButton;
